import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';
import { WA_DEFAULT_LINK } from '../lib/lead';

export default function NotFound() {
  return (
    <main className="min-h-[70vh] flex items-center justify-center bg-[#F8FAFC] px-4" data-testid="not-found-page">
      <div className="text-center max-w-lg py-20">
        <motion.p
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
          className="font-display text-8xl sm:text-9xl font-bold text-brand-blue"
        >
          4<span className="text-brand-orange">0</span>4
        </motion.p>
        <h1 className="mt-2 font-display text-3xl sm:text-4xl font-bold text-brand-ink">Page Off-Track</h1>
        <p className="mt-4 text-slate-500">
          The page you are looking for has been moved or does not exist. Return to Settalkar home to clear your traffic
          challans.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 rounded-xl bg-brand-blue hover:bg-brand-bluedark text-white font-bold px-6 py-3.5 transition-all hover:-translate-y-0.5"
            data-testid="not-found-home-cta"
          >
            <ArrowLeft size={17} /> Back to Settalkar Home
          </Link>
          <a
            href={WA_DEFAULT_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-xl border-2 border-brand-orange text-brand-orange hover:bg-brand-orange hover:text-white font-bold px-6 py-3.5 transition-all"
            data-testid="not-found-whatsapp-cta"
          >
            WhatsApp a Legal Expert
          </a>
        </div>
      </div>
    </main>
  );
}
